"use client";

import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowUp } from 'lucide-react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkScroll = () => {
      // Check both window scroll and the snap-container scroll (used on homepage)
      const container = document.querySelector('.snap-container');
      const scrollY = container ? container.scrollTop : window.scrollY;
      
      if (scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Initial check
    checkScroll();

    // Listen to window scroll
    window.addEventListener('scroll', checkScroll, { passive: true });
    
    // Also listen to the snap-container if it exists (for the home page)
    const container = document.querySelector('.snap-container');
    if (container) {
      container.addEventListener('scroll', checkScroll, { passive: true });
    }

    return () => {
      window.removeEventListener('scroll', checkScroll);
      if (container) {
        container.removeEventListener('scroll', checkScroll);
      }
    };
  }, [location.pathname]); // Re-run when route changes to catch the homepage container

  const scrollToTop = () => {
    const container = document.querySelector('.snap-container');
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          onClick={scrollToTop}
          className="fixed bottom-6 right-20 md:bottom-10 md:right-28 z-[150] p-4 rounded-full bg-fuchsia-600 text-white shadow-[0_0_20px_rgba(217,70,239,0.4)] hover:bg-fuchsia-500 hover:scale-110 active:scale-95 transition-all group"
          aria-label="Back to top"
        >
          <ArrowUp className="w-6 h-6 group-hover:-translate-y-1 transition-transform" />
          
          {/* Subtle pulse effect */}
          <span className="absolute inset-0 rounded-full bg-fuchsia-500 animate-ping opacity-20 pointer-events-none" />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;